/*
 * The pricing models a submission can be assigned (Inputs > Program > Model).
 *
 * The list lives in the `classifications` static config under `models`, as
 * `[{ key, name }]`. Companies that predate that key still get the list the
 * selector used to hard-code, so switching the source changes nothing for them.
 */

export const DEFAULT_MODELS = [
  { key: "WORKERS_COMP", name: "Workers' Comp" },
  { key: "NON_WORKERS_COMP", name: "General Casualty" },
  { key: "CASUALTY_CLASH", name: "Casualty Clash" },
  { key: "UMBRELLA", name: "Umbrella" },
  { key: "AUTO", name: "Auto" },
  { key: "MEDICAL_MALPRACTICE", name: "Medical Malpractice" },
];

const isModel = (model) =>
  model != null &&
  typeof model === "object" &&
  typeof model.key === "string" &&
  model.key !== "";

// The configured models, or the defaults when the config carries none.
export const selectModels = (classificationsConfig) => {
  const configured = classificationsConfig?.models;
  if (!Array.isArray(configured)) {
    return DEFAULT_MODELS;
  }
  const models = configured.filter(isModel);
  return models.length > 0 ? models : DEFAULT_MODELS;
};

// The display name of a model key, falling back to the key itself so an
// unknown or not yet loaded key still reads.
export const modelName = (modelKey, models) => {
  if (modelKey == null || modelKey === "") {
    return "";
  }
  const match = (Array.isArray(models) ? models : []).find(
    (model) => model?.key === modelKey
  );
  return match?.name || String(modelKey);
};
